import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=c0704cda&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=c0704cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0704cda",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,MtCheckbox: require('/home/bitrix/frontend/components/form/MtCheckbox.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,Hint: require('/home/bitrix/frontend/components/other/Hint.vue').default})
